export const config = {
  azureAD: {
    appID: process.env.REACT_APP_AZURE_APP_ID,
    redirectUri: process.env.REACT_APP_REDIRECT_URI,
    authority: process.env.REACT_APP_AUTHORITY,
    scopesStorageAccount: [process.env.REACT_APP_SCOPE_STORAGE_ACCOUNT],
    scopesGraph: [process.env.REACT_APP_SCOPE_GRAPH],
    scopesFamilyApi: [process.env.REACT_APP_SCOPE_GRAPH_FAMILYLIFE_API],
  },
  apiEndpoints: {
    familyLifeBaseUri: process.env.REACT_APP_FAMILYLIFE_BASE_URI
  }
};
